<template>
  <v-container class="pt-0">
    <v-row class="justify-center">
      <!-- <v-card-title class="breakword"
        >Do you need help finding the best extension type for you?</v-card-title
      > -->

      <v-col class="d-flex justify-center mt-3" cols="12"
        ><v-btn
          class="text-none text-wrap"
          depressed
          @click="handleSelect('sf')"
          width="100%"
          height="60"
          :color="answer === 'sf' ? 'user_cta' : 'user_btn'"
          :dark="answer === 'sf'"
          style="line-height: 1.5; padding: 16px 24px"
          >Help me find the Hairdreams<br />
          extension system that's best for me</v-btn
        ></v-col
      ><v-col class="d-flex justify-center pt-0" cols="12"
        ><v-btn
          width="100%"
          height="60"
          class="text-none text-wrap"
          depressed
          @click="handleSelect('c')"
          :color="answer === 'c' ? 'user_cta' : 'user_btn'"
          :dark="answer === 'c'"
          style="line-height: 1.5; padding: 16px 24px"
          >I know which Hairdreams <br />
          extension system I want</v-btn
        ></v-col
      ></v-row
    >
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        screen: 'extensions',
        question: 'systemPickedBy',
        answer: ''
      }
    },
    computed: {
      nextScreen() {
        if (this.answer === 'sf') return 'hairLongIs'
        else return 'consumerPick'
      }
    },
    methods: {
      // helper
      emitSelect(goNext = false) {
        this.$emit('select', {
          // note:
          clearUrl: true,
          screen: this.screen,
          nextScreen: this.nextScreen,
          question: this.question,
          answer: this.answer,
          goNext
        })
      },
      handleSelect(answer) {
        this.answer = answer
        this.emitSelect(true)
      }
    },
    created() {
      this.answer = this.$route.query[this.question] || ''
      this.emitSelect()
    }
  }
</script>

<style lang="scss" scoped>
  .breakword {
    word-break: break-word;
  }
</style>
